"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authImpression = void 0;

var _Schema = require("../../Schema");

/**
 * Action fired when a user views an authentication form
 *
 * @example
 *  ```
 *  authImpression({
 *    contextModule: ContextModule.header,
 *    intent: Intent.viewEditorial,
 *    type: AuthModalType.signup,
 *  })
 * ```
 */
const authImpression = ({
  contextModule,
  intent,
  copy,
  onboarding,
  trigger,
  triggerSeconds,
  type
}) => {
  return {
    action: _Schema.ActionType.authImpression,
    context_module: contextModule,
    intent,
    modal_copy: copy,
    onboarding: onboarding || false,
    trigger: trigger || triggerSeconds && "timed" || "click",
    trigger_seconds: triggerSeconds,
    type
  };
};

exports.authImpression = authImpression;